import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { telegram } from '../telegram/bridge';
import { useI18n } from '../i18n/I18nProvider';

export function ScreenHeader({ title, onBack, leading, action }: { title: string; onBack?: () => void; leading?: ReactNode; action?: ReactNode }) {
  const { t } = useI18n();
  return (
    <header className="screen-header">
      <span className="screen-header__side">
        {onBack && !telegram.isAvailable() && <button className="icon-button" onClick={onBack} aria-label={t('common.back')}><ArrowLeft /></button>}
        {leading}
      </span>
      <strong>{title}</strong>
      <span className="screen-header__side screen-header__side--end">{action}</span>
    </header>
  );
}
